module.exports = __webpack_public_path__ + "static/Loader_03_optimized.ee827d21.gif";